import axios from "axios";

const rawBase = (process.env.REACT_APP_API_BASE_URL || "").trim().replace(/\/+$/, "");

const apiClient = axios.create({
  baseURL: rawBase || undefined,
  headers: { "Content-Type": "application/json" },
  withCredentials: true, // required for cookie auth
});

// login request just works; cookie will be stored automatically by browser
apiClient.interceptors.response.use(
  (res) => res,
  (error) => {
    console.error("API response error:", error?.response?.status, error?.response?.data || error?.message);
    return Promise.reject(error);
  }
);

export default apiClient;